var paragraph_default = {
  "fontElementMap": "lX1Gn",
  "elementSpacing": "Fg5BJ",
  "text": "kFB2b Fg5BJ",
  "child": "_5bJSe"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
